module.exports = __webpack_public_path__ + "media/images/img-car-6-0c521652.png";